import * as React from "react";
import {OptionList} from "./OptionList";
import EnumField from "../../../metamodel/Fields/EnumField";
import EnumOption from "../../../metamodel/Fields/EnumOption";
import {FieldBehaviors} from "../../../metamodel/IField";
import {FieldFacet} from "../../types";

// tslint:disable-next-line:interface-name
export interface EnumFilterFieldProps {
    field: EnumField,
    facet: FieldFacet,
    selected: string[],
    disableFacet?: boolean,
    onChange?: (values: string[]) => void
}

export default class EnumFilterField extends React.Component<EnumFilterFieldProps> {

    constructor(props: EnumFilterFieldProps) {
        super(props);
    }

    public render(): React.ReactNode {
        const onChange = (f: EnumOption[]) => this.props.onChange && this.props.onChange(f.map(v => v.key));
        return <OptionList
            id={this.props.field.id}
            name={this.props.field.name}
            options={this.props.field.options}
            facet={this.props.facet}
            selected={this.props.selected}
            disableFacet={this.props.disableFacet}
            collapsed={(this.props.field.behaviors & FieldBehaviors.DefaultCollapsed) !== 0}
            onChange={onChange}
        />;
    }
}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/EnumFilterField.tsx